import { CSSResultArray, html, TemplateResult, unsafeCSS } from 'lit';
import { customElement } from 'lit/decorators.js';
import { Constants } from './product-center-predictive-popover.constants';
import { PopProductCenterPopover } from '../../../views/performance-tiles/product-center-popover/product-center-popover';
import style from './product-center-predictive-popover.scss?inline';

/**
 * @tag pop-product-center-predictive-popover
 */
@customElement(Constants.TAG_NAME)
export class PopProductCenterPredictivePopover extends PopProductCenterPopover {
  static get styles(): CSSResultArray {
    const parentStyles = super.styles;
    // Return the combined styles
    return [parentStyles, unsafeCSS(style)];
  }

  protected renderCloseButton(): TemplateResult {
    return html``;
  }

  protected renderArrow(): TemplateResult {
    return html``;
  }

  protected renderOverlayWrapper(): TemplateResult {
    return super.renderPredictiveSearchOverlayWrapper();
  }
}
